import { ReactNode } from "react";

import { Language } from "../../../../../services";

import parkNumber from "./parkNumber";
import aliases from "./aliases";
import mark from "./mark";
import model from "./model";
import vehicleClass from "./vehicleClass";
import bodyType from "./bodyType";
import registeredAt from "./registeredAt";
import responsibleDispatcher from "./responsibleDispatcher";
import company from "./company";
import taxiService from "./taxiService";
import color from "./color";
import note from "./note";
import registrationNumber from "./registrationNumber";
import carParkId from "./carParkId";

const translationTablePath = `carSelectTab`;

export enum ColumnId {
	ParkNumber = "parkNumber",
	Aliases = "aliases",
	Mark = "mark",
	Model = "model",
	RegistrationNumber = "registrationNumber",
	Color = "color",
	Class = "class",
	BodyType = "bodyType",
	RegisteredAt = "registeredAt",
	CarParkId = "carParkId",
	ResponsibleDispatcher = "responsibleDispatcher",
	Company = "company",
	TaxiService = "taxiService",
	Note = "note",
}

export interface Column {
	render: (options: Column.Options) => ReactNode;
	label: string | string[];
}

export declare namespace Column {
	interface Options {
		width?: number;
		language: Language;
		onResize?: (width: number, columnId: ColumnId) => void;
	}
}

export const columns: Record<ColumnId, Column> = {
	[ColumnId.ParkNumber]: {
		render: parkNumber,
		label: [`${translationTablePath}.parkNumber`, "Park Number"],
	},
	[ColumnId.Aliases]: {
		render: aliases,
		label: [`${translationTablePath}.aliases`, "Aliases"],
	},
	[ColumnId.Mark]: {
		render: mark,
		label: [`${translationTablePath}.mark`, "Mark"],
	},
	[ColumnId.Model]: {
		render: model,
		label: [`${translationTablePath}.model`, "Model"],
	},
	[ColumnId.RegistrationNumber]: {
		render: registrationNumber,
		label: [
			`${translationTablePath}.${ColumnId.RegistrationNumber}`,
			"Registration Number",
		],
	},
	[ColumnId.Color]: {
		render: color,
		label: [`${translationTablePath}.color`, "Color"],
	},
	[ColumnId.Class]: {
		render: vehicleClass,
		label: [`${translationTablePath}.class`, "Class"],
	},
	[ColumnId.BodyType]: {
		render: bodyType,
		label: [`${translationTablePath}.bodyType`, "Body Type"],
	},
	[ColumnId.RegisteredAt]: {
		render: registeredAt,
		label: [`${translationTablePath}.registeredAt`, "Registered At"],
	},
	[ColumnId.CarParkId]: {
		render: carParkId,
		label: [`${translationTablePath}.carParkId`, "CarPark"],
	},
	[ColumnId.ResponsibleDispatcher]: {
		render: responsibleDispatcher,
		label: [
			`${translationTablePath}.responsibleDispatcher`,
			"Responsible Dispatcher",
		],
	},
	[ColumnId.Company]: {
		render: company,
		label: [`${translationTablePath}.company`, "Company"],
	},
	[ColumnId.TaxiService]: {
		render: taxiService,
		label: [`${translationTablePath}.taxiService`, "Taxi Service"],
	},

	[ColumnId.Note]: {
		render: note,
		label: [`${translationTablePath}.note`, "Note"],
	},
};

export const defaultColumnIds: ColumnId[] = [
	ColumnId.ParkNumber,
	ColumnId.Aliases,
	ColumnId.Mark,
	ColumnId.RegistrationNumber,
	ColumnId.Color,
	ColumnId.Model,
	ColumnId.Class,
	ColumnId.BodyType,
	ColumnId.RegisteredAt,
	ColumnId.CarParkId,
	ColumnId.ResponsibleDispatcher,
	ColumnId.Company,
	ColumnId.TaxiService,

	ColumnId.Note,
];

export const disabledColumnsIds: ColumnId[] = [];

export default columns;
